// Steps
const container = document.getElementById("pdp_purchase_container");
let currentStep = 1;
let cartParams = "";

// Handle Steps
const handleStep = (nextOrPrev) => {
  const stepTo = nextOrPrev === "next" ? currentStep + 1 : currentStep - 1;
  currentStep = stepTo;
  container.dataset.currentStep = stepTo;
};

// Back Buttons
const backButtons = container.querySelectorAll(".step-back");
backButtons.forEach((option) => {
  option.addEventListener("click", (e) => {
    e.preventDefault();
    handleStep("prev");
  });
});

// Go to Cart
const goToCart = (cartParams) => {
  window.location.href = `https://onecountry.com/cart/add?${cartParams}&return_to=/checkout`;
};

// Step One: Purchase Options
const purchaseOptions = container.querySelectorAll(
  "a.option--one-time, a.option--subscribe",
);
purchaseOptions.forEach((option) => {
  option.addEventListener("click", (e) => {
    e.preventDefault();
    const params = new URL(option.href).searchParams;
    const variant = params.get("id") || null;
    const sellingPlan = params.get("selling_plan") || null;
    cartParams = sellingPlan
      ? `items[][id]=${variant}&items[][quantity]=1&items[][selling_plan]=${sellingPlan}`
      : `items[][id]=${variant}&items[][quantity]=1`;
    handleStep("next");
  });
});

// Step Two: Bonus Options
const bonusEnterOptions = container.querySelectorAll(
  ".option--bonus .option__button--enter",
);
bonusEnterOptions.forEach((option) => {
  option.addEventListener("click", (e) => {
    e.preventDefault();
    cartParams += `&items[][id]=${option.dataset.variant}&items[][quantity]=1`;
    goToCart(cartParams);
  });
});

const bonusSkipOptions = container.querySelectorAll(
  ".option--bonus .option__button--skip",
);
bonusSkipOptions.forEach((option) => {
  option.addEventListener("click", (e) => {
    e.preventDefault();
    goToCart(cartParams);
  });
});
